import { useModal } from 'components/modal/ModalStack';
import { classNames } from 'libs/react';
import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './DealItemPickerPackageDetail.scss';
/**
 * @component DealItemPickerPackageDetail
 * @since 1.0.0
 */
export function DealItemPickerPackageDetail(props) {
    var _a, _b;
    const { style, data, appendPackage, hideButton } = Object.assign({ style: 'normal' }, props);
    const modal = useModal();
    /**
     * @function onSelectPackagePress
     * @since 1.0.0
     * @hidden
     */
    function onSelectPackagePress() {
        appendPackage && appendPackage(data, false, 1);
        modal.dismiss();
    }
    const className = classNames('deal-item-picker-package-detail', 'deal-item-picker-package-detail--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "deal-item-picker-package-detail-body" },
            React.createElement("div", { className: "deal-item-picker-package-detail-infos" },
                React.createElement(Icon, { className: "deal-item-picker-package-detail-picto", value: (_a = data.icon) !== null && _a !== void 0 ? _a : undefined }),
                React.createElement(Text, { className: "deal-item-picker-package-detail-title", value: data.title })),
            React.createElement("div", null,
                React.createElement("div", { dangerouslySetInnerHTML: { __html: data.infos } })),
            (data === null || data === void 0 ? void 0 : data.saleItems) && data.saleItems.length > 0 ? (React.createElement(React.Fragment, null,
                React.createElement("h3", null, t('Included options')),
                React.createElement("ul", { className: "deal-item-picker-package-detail-options" }, (_b = data === null || data === void 0 ? void 0 : data.saleItems) === null || _b === void 0 ? void 0 : _b.filter((item) => !item.required).map((item) => (React.createElement("li", { key: item.item.id, className: "deal-item-picker-package-detail-option" }, item.item.title)))))) : null),
        React.createElement("div", { className: "deal-item-picker-package-detail-foot" }, hideButton && (React.createElement(Button, { style: "primary", label: t('Select Package'), onPress: onSelectPackagePress })))));
}
